/*****
 * Created with vscode
 * Name : 滑动 tab 列表
 * Date : 2020/2/28
 * Author : Bevis Shen
 * Func :
 *  dataList: 注入数据
 *  on-select: 点击选项回调方法
 ******/

<template>
  <div class="layout-slider-bar">
    <div class="slider-wrap">
      <div
        class="slider-bar"
        v-for="(item, i) in dataList"
        :key="i"
        :class="item.code === activeArea ? 'active': null"
        @click="activeTab(item.code)"
      >
        {{item.name}}
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: 'SliderBar',
  props: {
    dataList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      activeArea: ''
    }
  },
  created () {
    this.activeArea = '' // 全部
  },
  mounted () {
  },
  methods: {
    activeTab (code) {
      this.activeArea = code
      this.$emit('on-select', this.activeArea)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SliderBar.vue